<template>
  <div>
    <template v-if="$store.getters.getUserHasFeature('messages')">
      <message-form />
    </template>
    <template v-else>
      <div class="wrapper pt-3 pb-1">
        <f-alert
          visible
          class="my-2"
          theme="inactive">
          <span>
          {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
          </span>
        </f-alert>
      </div>
    </template>
  </div>
</template>

<script>
import MessageForm from '@/views/forms/message/MessageForm.vue';

export default {
  name: 'message-form-wrapper',
  components: {
    'message-form': MessageForm
  }
}
</script>
